import React from 'react';
import {
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

interface Props {
  children: React.ReactNode;
  title: string | React.ReactNode;
}

const MuiTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: '#333',
    marginLeft: '80px!important',

    '& .MuiTypography-root': {
      fontSize: 14,

      '& a': {
        color: '#635bff',
        fontWeight: 500,
        textDecoration: 'none',
      },
    },
  },
});

const ObTooltip: React.FC<Props> = ({ children, title, ...props }) => {
  const theme = useTheme();
  const large = useMediaQuery(theme.breakpoints.up('lg'));

  // Render title component
  const renderTitle = () => {
    if (typeof title === 'string') {
      return <Typography variant="body2">{title}</Typography>;
    }

    return title;
  };

  if (!large) return <>{children}</>;

  return (
    <MuiTooltip title={renderTitle()} placement="right" {...props}>
      <div>{children}</div>
    </MuiTooltip>
  );
};

export default ObTooltip;
